/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostUsersMeAnswererUploadProfileImage200Response
 */
export interface PostUsersMeAnswererUploadProfileImage200Response {
    /**
     * 
     * @type {string}
     * @memberof PostUsersMeAnswererUploadProfileImage200Response
     */
    filePath?: string;
}

/**
 * Check if a given object implements the PostUsersMeAnswererUploadProfileImage200Response interface.
 */
export function instanceOfPostUsersMeAnswererUploadProfileImage200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostUsersMeAnswererUploadProfileImage200ResponseFromJSON(json: any): PostUsersMeAnswererUploadProfileImage200Response {
    return PostUsersMeAnswererUploadProfileImage200ResponseFromJSONTyped(json, false);
}

export function PostUsersMeAnswererUploadProfileImage200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUsersMeAnswererUploadProfileImage200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
    };
}

export function PostUsersMeAnswererUploadProfileImage200ResponseToJSON(value?: PostUsersMeAnswererUploadProfileImage200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filePath': value.filePath,
    };
}

